import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const DisclaimerPhoneValidationWrapper = styled.div`
  .disclaimer__phone__validation--v2 {
    padding-left: 20px;
    border-left: 10px solid #e1dbd4;
    margin-top: 60px;
    margin-bottom: 40px;
  }
`;

export type DisclaimerPhoneValidationV2Props = {
  className?: string;
};

export const DisclaimerPhoneValidationV2 = ({ className }: DisclaimerPhoneValidationV2Props) => {
  const { t } = useTranslation();

  return (
    <DisclaimerPhoneValidationWrapper>
      <div className={`disclaimer__phone__validation--v2 max-w-6xl m-auto ${className}`}>
        <p className="text-md-mediumGray">{t('DisclaimerPhoneValidation.claimText1')}</p>
        <p className="text-md-mediumGray">{t('DisclaimerPhoneValidation.claimText2')}</p>
        <p className="text-md-mediumGray">{t('DisclaimerPhoneValidation.claimText3')}</p>
        <p className="text-md-mediumGray">{t('DisclaimerPhoneValidation.claimText4')}</p>
        <p className="text-md-mediumGray">{t('DisclaimerPhoneValidation.claimText5')}</p>
        <p className="text-md-mediumGray">{t('DisclaimerPhoneValidationV2.claimText8')}</p>
      </div>
    </DisclaimerPhoneValidationWrapper>
  );
};
